import React from "react";
import { IconProps } from "../../types/types";

const BankingFinanceIcon: React.FC<IconProps> = ({
  size = "18",
  color = "white",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.75001 8.36255H5.25001"
        stroke={color}
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.49999 8.36262V4.89763C1.49999 3.36763 2.73749 2.13013 4.26749 2.13013H8.48249C10.0125 2.13013 11.25 3.08262 11.25 4.61262"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.11 9.15004C12.735 9.51004 12.555 10.065 12.705 10.635C12.8925 11.3325 13.5825 11.775 14.3025 11.775H15V12.8625C15 14.52 13.6575 15.8625 12 15.8625H4.49999C2.84249 15.8625 1.49999 14.52 1.49999 12.8625V7.61255C1.49999 5.95505 2.84249 4.61255 4.49999 4.61255H12C13.65 4.61255 15 5.96255 15 7.61255V8.70001H14.19C13.77 8.70001 13.3875 8.86504 13.11 9.15004Z"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 9.46497V11.01C16.5 11.43 16.155 11.775 15.7275 11.775H14.28C13.47 11.775 12.7275 11.1825 12.66 10.3725C12.615 9.89998 12.795 9.45748 13.11 9.14998C13.3875 8.86498 13.77 8.69995 14.19 8.69995H15.7275C16.155 8.69995 16.5 9.04497 16.5 9.46497Z"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BankingFinanceIcon;
